import { ComplianceCourseWithUserId } from '../ManagePlansComplianceCard';

import {
  AssignableCourseResult,
  PathwayUser,
} from '@/_generated/api-clients/xp';

export const useTotalTeamMembers = (
  teamMembers: PathwayUser[] | undefined,
  isAssignedCoursesSuccess: boolean,
  complianceStatus: AssignableCourseResult | undefined,
) => {
  if (
    !isAssignedCoursesSuccess ||
    complianceStatus?.enrollments === undefined ||
    teamMembers === undefined
  ) {
    return 0;
  }

  const uniqueVisibleUserIds = new Set<string>();

  teamMembers.forEach(teamMember => {
    const adId = teamMember.adId;
    if (!adId) {
      return;
    }

    const enrollment = complianceStatus.enrollments?.[adId];
    const userId =
      (enrollment as ComplianceCourseWithUserId | undefined)?.userId ?? adId;
    const hidden = enrollment?.hidden ?? false;
    if (!hidden && userId) {
      uniqueVisibleUserIds.add(userId);
    }
  });

  return uniqueVisibleUserIds.size;
};
